import { JDSVerticalStepItemProps } from './generated/interface';
import { useRootRef } from '../../hooks/useRootRef';

export const withLogic =
  (
    Component: React.ComponentType<JDSVerticalStepItemProps>
  ): React.FC<JDSVerticalStepItemProps> =>
  (props: JDSVerticalStepItemProps) => {
    const active = props.state === 'active';
    const { element, rootRef } = useRootRef();
    return (
      <Component
        {...{
          ...props,
          rootRef,
          _hideChild: active,
          _contentHeight: active
            ? element?.querySelector<HTMLDivElement>('div#content-container')
                ?.scrollHeight
            : 0
        }}
      />
    );
  };
